/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const createDailyActivityMonitoringLogHeaderInputDtoBranchIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const CreateDailyActivityMonitoringLogHeaderInputDto = zod.object({
  "branchId": zod.union([zod.number(),zod.string().regex(createDailyActivityMonitoringLogHeaderInputDtoBranchIdRegExpTwo)]).optional()
});

export type CreateDailyActivityMonitoringLogHeaderInputDto = zod.input<typeof CreateDailyActivityMonitoringLogHeaderInputDto>;
export type CreateDailyActivityMonitoringLogHeaderInputDtoOutput = zod.output<typeof CreateDailyActivityMonitoringLogHeaderInputDto>;
